import { render, staticRenderFns } from "./download.vue?vue&type=template&id=99578a8c&scoped=true&lang=pug"
var script = {}
import style0 from "./download.vue?vue&type=style&index=0&id=99578a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99578a8c",
  null
  
)

export default component.exports